export const isValidCPF = (cpf: string): boolean => {
  if (typeof cpf !== 'string') return false;
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false;
  const cpf_parts = cpf.split('').map(el => +el);
  const rest = (count: any) =>
    ((cpf_parts
      .slice(0, count - 12)
      .reduce((soma, el, index) => soma + el * (count - index), 0) *
      10) %
      11) %
    10;
  return rest(10) === cpf_parts[9] && rest(11) === cpf_parts[10];
};

export const cnpjPattern = ['99.999.999/9999-99'];

export const removeDotsAndTracesCPF = (cpf: string) => {
  let cpfLimpo = cpf.replace(/[.-]/g, '');
  return cpfLimpo;
};
